import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M44 24c0 11.047-8.953 20-20 20S4 35.047 4 24 12.954 4 24 4c11.047 0 20 8.954 20 20m-2 0c0-9.942-8.057-18-18-18S6 14.057 6 24s8.057 18 18 18 18-8.057 18-18m-14.31 9.69a1 1 0 0 0 0-1.414l-7.234-7.23a1.5 1.5 0 0 1-.001-2.12l7.217-7.237a1 1 0 1 0-1.417-1.412l-7.216 7.236a3.5 3.5 0 0 0 .003 4.947l7.234 7.23a1 1 0 0 0 1.415 0",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Circled-Left-Outlined_svg__a",
      width: 40,
      height: 40,
      x: 4,
      y: 4,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M44 24c0 11.047-8.953 20-20 20S4 35.047 4 24 12.954 4 24 4c11.047 0 20 8.954 20 20m-2 0c0-9.942-8.057-18-18-18S6 14.057 6 24s8.057 18 18 18 18-8.057 18-18m-14.31 9.69a1 1 0 0 0 0-1.414l-7.234-7.23a1.5 1.5 0 0 1-.001-2.12l7.217-7.237a1 1 0 1 0-1.417-1.412l-7.216 7.236a3.5 3.5 0 0 0 .003 4.947l7.234 7.23a1 1 0 0 0 1.415 0",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Circled-Left-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgCircledLeftOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CircledLeftOutlined_default = SvgCircledLeftOutlined;

export { CircledLeftOutlined_default as default };
